<template>
  <tr
    class="hover:bg-gray-50 transition-colors duration-150 ease-in-out child:p-2 first-child:pl-2 last-child:pr-2 bg-white child:border-b child:border-gray-200"
  >
    <td class="py-2">
      <div class="flex space-x-2 items-center">
        <div
          v-if="nextAction.timeBar"
          :title="nextAction.timeBar.text"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"
            :style="{ color: nextAction.timeBar.colour }">
    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
</svg>
        </div>

        <button
          v-if="!readOnly"
          type="button"
          class="btn-icon btn-icon-blue"
          @click="$emit('showVariation', variationOrder)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"  class="w-5 h-5">
    <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
</svg>
        </button>

        <button
          v-if="!readOnly"
          type="button"
          class="btn-icon btn-icon-blue"
          @click="$emit('openCorrespondenceModal', variationOrder)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
</svg>
        </button>

        <button
          type="button"
          data-test="show-comments"
          class="btn-icon btn-icon-blue"
          @click="$emit('openCommentModal', variationOrder)"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="h-5 w-5">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <button
          v-if="!readOnly"
          type="button"
          class="btn-icon"
          :class="variationOrder.hasMedia ? 'btn-icon-blue' : 'btn-icon-default'"
          :title="variationOrder.hasMedia ? 'View attachments' : 'No attachments'"
          @click="$emit('showVariationAttachments', variationOrder)"
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="h-5 w-5">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"/>
</svg>
        </button>

        <p
          class="text-wrap w-60 text-gray-900"
          :title="variationOrder.description"
        >
          <span class="text-sm font-medium text-gray-900">{{ variationOrder.code }}</span>
          {{ variationOrder.description }}
        </p>
      </div>
    </td>

    <td>
      {{ variationOrder.dateOfOccurrence?.toLocaleString() }}
    </td>

    <td>
      {{ variationOrder.client_ref }}
    </td>

    <td class="px-6 py-5 whitespace-nowrap">
      <span
        v-if="variationOrder.isTransferred"
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800"
      >
        {{ transferredStatusLabel }}
      </span>

      <span
        v-else
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
        :style="{ color: VariationOrderStatusTextColours[enumKeyFromValue(VariationOrderStatus, variationOrder.status)], backgroundColor: VariationOrderStatusColours[enumKeyFromValue(VariationOrderStatus, variationOrder.status)] }"
      >
        {{ variationOrder.statusTitle }}
      </span>
    </td>

    <td class="text-right">
      <div class="flex items-center justify-end space-x-2">
        <span
          v-if="variationOrder.totalBudget && !editingSumPrice"
          class="text-sm font-medium text-gray-900"
        >
          <div class="group flex items-center justify-end">
            <button
              v-if="!readOnly && !project?.isContractor && canEditSumPrice"
              type="button"
              class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
              @click="editSumPrice"
            >
              <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
            </button>
            {{ variationOrder.totalBudget ? $tcc(variationOrder.totalBudget) : '' }}
          </div>
        </span>

        <template v-else-if="project?.isContractor">
          <div v-if="!readOnly && project.unarchived && !variationOrder.isTransferred && !variationOrder.totalBudget && (variationOrder.status === VariationOrderStatus.registered || variationOrder.status === VariationOrderStatus.principled || variationOrder.status === VariationOrderStatus.priced)">
            <AppCurrencyInput
              v-model.number="sumPrice"
              name="pricing"
              class="form-input w-20 p-1 text-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              @blur="priceVariationOrder"
              @keyup.enter="priceVariationOrder"
            />
          </div>
        </template>
        <!-- Client Projects -->
        <template v-else>
          <div v-if="!readOnly && project.unarchived && !variationOrder.isTransferred && (variationOrder.status === VariationOrderStatus.registered || variationOrder.status === VariationOrderStatus.principled || variationOrder.status === VariationOrderStatus.priced)">
            <AppCurrencyInput
              ref="sumPriceInput"
              v-model.number="sumPrice"
              name="pricing"
              class="form-input w-20 p-1 text-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              @blur="priceVariationOrder"
              @keyup.enter="$event.target.blur()"
              @keyup.esc="cancelEditSumPrice"
            />
          </div>
        </template>
      </div>
    </td>

    <td v-if="project?.unarchived">
      <p
        class="text-wrap w-60 text-gray-900 text-sm"
        :title="nextAction.nextActionText"
      >
        {{ nextAction.nextActionText }}
      </p>
    </td>

    <td v-if="project?.unarchived && !readOnly">
      <div
        v-if="!variationOrder.isTransferred"
        class="flex flex-col space-y-1"
      >
        <div class="flex space-x-1 justify-between">
          <div class="group">
            <div class="flex justify-between">
              <span class="text-xs font-medium text-gray-500">
                {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.label.assignee') }}
              </span>

              <button
                type="button"
                @click="clearAssignee"
              >
                <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="text-red-600 w-5 h-5 invisible group-hover:visible">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
              </button>
            </div>

            <AppTypeAhead
              v-model="userNameTypeAhead"
              class="w-full"
              name="category_name"
              :suggestion-callback="getSuggestions"
              :initial-suggestions="getSuggestions"
              @value-selected="selectUser"
            />
          </div>

          <div class="group">
            <div class="flex justify-between">
              <span class="text-xs font-medium text-gray-500">
                {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.label.dueDate') }}
              </span>

              <button
                type="button"
                @click="clearDate"
              >
                <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="text-red-600 w-5 h-5 invisible group-hover:visible">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
              </button>
            </div>

            <AppInput
              v-model="nextActionDueDate"
              name="next_action_due_date"
              type="date"
              class="form-input text-sm"
            />
          </div>
        </div>

        <div class="space-y-1">
          <label class="block text-xs font-medium text-gray-500">
            {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.label.nextAction') }}
          </label>

          <textarea
            v-model="manualNextAction"
            name="next_action"
            class="form-input text-sm resize-none border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            rows="2"
            placeholder="Enter next action..."
            @blur="saveNextAction"
            @keyup.enter="saveNextAction"
          />
        </div>
      </div>
    </td>

    <td
      v-if="project?.unarchived && !readOnly"
      @click.stop=""
    >
      <div
        v-if="!variationOrder.isTransferred"
        class="grid grid-cols-1 gap-2"
      >
        <template v-if="project.isContractor">
          <button
            v-if="!variationOrder.notice_sent_at && variationOrder.status >= VariationOrderStatus.registered && variationOrder.status < VariationOrderStatus.declined"
            type="button"
            class="btn--small btn btn--secondary-blue"
            @click="$emit('sendNotice', variationOrder)"
          >
            {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.sendNotice') }}
          </button>

          <template
            v-if="variationOrder.status === VariationOrderStatus.raised"
          >
            <button
              type="button"
              class="btn--small btn btn--primary-green"
              @click="$emit('acceptVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.accept') }}
            </button>

            <button
              type="button"
              class="btn--small btn btn--primary-alert"
              @click="$emit('declineVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.decline') }}
            </button>
          </template>

          <template
            v-else-if="variationOrder.status === VariationOrderStatus.registered"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('priceVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.addPricing') }}
            </button>

            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('principleVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.approveInPrinciple') }}
            </button>
          </template>

          <template
            v-else-if="variationOrder.status === VariationOrderStatus.priced"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('priceVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.addPricing') }}
            </button>

            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('submitVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.submit') }}
            </button>

            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('principleVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.approveInPrinciple') }}
            </button>
          </template>

          <template
            v-else-if="variationOrder.status === VariationOrderStatus.submitted"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('submitVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.resubmit') }}
            </button>

            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('principleVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.approveInPrinciple') }}
            </button>
          </template>

          <template
            v-else-if="variationOrder.status === VariationOrderStatus.principled"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('priceVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.addPricing') }}
            </button>

            <button
              v-if="variationOrder.totalBudget"
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('submitVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.submit') }}
            </button>
          </template>

          <template
            v-else-if="variationOrder.status === VariationOrderStatus.provisioned"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('approveVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.approve') }}
            </button>
          </template>
        </template>

        <!-- Client Projects -->
        <template v-else>
          <template
            v-if="variationOrder.status === VariationOrderStatus.raised"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('registerNotice', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.registerNotice') }}
            </button>
          </template>

          <template v-if="variationOrder.status === VariationOrderStatus.registered">
            <button
              type="button"
              class="btn--small btn btn--secondary-blue min-w-max"
              @click="$emit('registerPricingNotice', variationOrder)"
            >
              Finalise Pricing
            </button>

            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('principleVariationOrder', variationOrder)"
            >
              Approve in Principle
            </button>
          </template>

          <template v-if="variationOrder.status === VariationOrderStatus.priced">
            <button
              type="button"
              class="btn--small btn btn--secondary-blue min-w-max"
              @click="$emit('registerPricingNotice', variationOrder)"
            >
              Finalise Pricing
            </button>

            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('principleVariationOrder', variationOrder)"
            >
              Approve in Principle
            </button>
          </template>

          <template v-if="variationOrder.status === VariationOrderStatus.principled">
            <button
              type="button"
              class="btn--small btn btn--secondary-blue min-w-max"
              @click="$emit('registerPricingNotice', variationOrder)"
            >
              Finalise Pricing
            </button>
          </template>

          <template
            v-if="variationOrder.status === VariationOrderStatus.provisioned"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue min-w-max"
              @click="$emit('registerPricingNotice', variationOrder)"
            >
              Finalise Repricing
            </button>

            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('principleVariationOrder', variationOrder)"
            >
              Approve in Principle
            </button>

            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('approveVariationOrder', variationOrder)"
            >
              {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.button.approve') }}
            </button>
          </template>
        </template>
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { dateForDateInput, enumKeyFromValue, plusBusinessDays } from '@/helpers';
import { t } from '@/i18n';
import VariationOrder, {
  VariationOrderStatus,
  VariationOrderStatusColours,
  VariationOrderStatusTextColours,
} from '@/models/VariationOrder';
import { useProjectsStore } from '@/store/projects';
import { useTemplateRef, watch } from 'vue';
import { computed, nextTick } from 'vue';
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{
    variationOrder: VariationOrder;
    readOnly?: boolean;
  }>(),
  {
    readOnly: false,
  },
);

const emits = defineEmits<{
  (e: 'showVariation', variationOrder: VariationOrder);
  (e: 'openCommentModal', variationOrder: VariationOrder);
  (e: 'acceptVariationOrder', variationOrder: VariationOrder);
  (e: 'declineVariationOrder', variationOrder: VariationOrder);
  (e: 'priceVariationOrder', variationOrder: VariationOrder);
  (e: 'principleVariationOrder', variationOrder: VariationOrder);
  (e: 'submitVariationOrder', variationOrder: VariationOrder);
  (e: 'approveVariationOrder', variationOrder: VariationOrder);
  (e: 'sumSetVariationOrder', data: { variationOrder: VariationOrder; sumPrice: number });
  (
    e: 'saveNextAction',
    data: {
      variationOrder: VariationOrder;
      next_action?: string;
      next_action_due_date?: string;
      next_action_assignee_id?: number;
    },
  );
  (e: 'sendNotice', variationOrder: VariationOrder);
  (e: 'registerNotice', variationOrder: VariationOrder);
  (e: 'registerPricingNotice', variationOrder: VariationOrder);
  (e: 'openCorrespondenceModal', variationOrder: VariationOrder);
  (e: 'showVariationAttachments', variationOrder: VariationOrder);
}>();

const manualNextAction = ref(props.variationOrder.next_action);
const nextActionAssignee = ref(props.variationOrder.next_action_assignee_id);
const nextActionDueDate = ref(dateForDateInput(props.variationOrder.next_action_due_date));

const clearAssignee = () => {
  userNameTypeAhead.value = '';
  nextActionAssignee.value = undefined;

  emits('saveNextAction', {
    variationOrder: props.variationOrder,
    next_action: manualNextAction.value,
    next_action_due_date: nextActionDueDate.value,
    next_action_assignee_id: undefined,
  });
};

const clearDate = () => {
  nextActionDueDate.value = '';

  emits('saveNextAction', {
    variationOrder: props.variationOrder,
    next_action: manualNextAction.value,
    next_action_due_date: undefined,
    next_action_assignee_id: nextActionAssignee.value,
  });
};

watch(nextActionDueDate, (newValue) => {
  const date = new Date(newValue);

  if(!isNaN(date.getTime())) {
    const year = newValue.split('-')[0];

    if(parseInt(year) > 2000) {
      emits('saveNextAction', {
        variationOrder: props.variationOrder,
        next_action: manualNextAction.value,
        next_action_due_date: nextActionDueDate.value,
        next_action_assignee_id: nextActionAssignee.value,
      });
    }
  }
});

const saveNextAction = () => {
  emits('saveNextAction', {
    variationOrder: props.variationOrder,
    next_action: manualNextAction.value,
    next_action_due_date: nextActionDueDate.value,
    next_action_assignee_id: nextActionAssignee.value,
  });
};

const canEditSumPrice = computed(() => {
  return !props.readOnly && !props.variationOrder.isTransferred && project.value?.unarchived && (
    props.variationOrder.status === VariationOrderStatus.registered ||
    props.variationOrder.status === VariationOrderStatus.principled ||
    props.variationOrder.status === VariationOrderStatus.priced
  );
});

const editingSumPrice = ref(false);
const sumPriceInput = useTemplateRef('sumPriceInput');

const editSumPrice = () => {
  editingSumPrice.value = true;
  sumPrice.value = props.variationOrder.totalBudget;

  nextTick(() => {
    sumPriceInput.value?.focusInput();
  });
};

const cancelEditSumPrice = () => {
  editingSumPrice.value = false;
};

const sumPrice = ref(props.variationOrder.totalBudget);

const priceVariationOrder = () => {
  if(sumPrice.value) {
    emits('sumSetVariationOrder', {
      variationOrder: props.variationOrder,
      sumPrice: sumPrice.value,
    });

    cancelEditSumPrice();
  }
};

const projectsStore = useProjectsStore();

const project = computed(() => {
  return projectsStore.project;
});

const noticeDueIn = computed(() => {
  if(props.variationOrder.dateOfOccurrence) {
    const dueDate = project.value.head_contract_settings.nov_business_days ?
      plusBusinessDays(
        props.variationOrder.dateOfOccurrence,
        project.value.head_contract_settings.holidays,
        project.value.head_contract_settings.nov_period,
      ) :
      props.variationOrder.dateOfOccurrence.plus({ days: project.value.head_contract_settings.nov_period });

    return Math.ceil(dueDate.diffNow('days').days);
  }

  return project.value.head_contract_settings.nov_period;
});

const pricingDueIn = computed(() => {
  // TODO: 09/04/25 allow from completion date, or from when notice was sent, or from date of occurrence

  if(props.variationOrder.dateOfOccurrence) {
    const dueDate = project.value.head_contract_settings.variation_submission_business_days ?
      plusBusinessDays(
        props.variationOrder.dateOfOccurrence,
        project.value.head_contract_settings.holidays,
        project.value.head_contract_settings.variation_submission_period,
      ) :
      props.variationOrder.dateOfOccurrence.plus({
        days: project.value.head_contract_settings.variation_submission_period,
      });

    return Math.ceil(dueDate.diffNow('days').days);
  }

  return project.value.head_contract_settings.variation_submission_period;
});

const transferredStatusLabel = computed(() => {
  const projectName = props.variationOrder.transferred_to_variation_order?.project?.name;

  if(projectName) {
    return t('HeadContract.VariationsSchedule.VariationOrderRow.transferredToProject', { project: projectName });
  }

  return t('HeadContract.VariationsSchedule.VariationOrderRow.transferred');
});

const nextAction = computed(() => {
  let nextActionText = '';

  if(!project.value.unarchived || props.variationOrder.isTransferred) {
    return {
      nextActionText: '',
      timeBar: undefined,
    };
  }

  if(!props.variationOrder.dateOfOccurrence) {
    return {
      nextActionText: t('HeadContract.VariationsSchedule.VariationOrderRow.setDateOfOccurrence'),
      timeBar: undefined,
    };
  }

  if(!props.variationOrder.requiresNotice) {
    return {
      nextActionText: '',
      timeBar: undefined,
    };
  }

  if(!props.variationOrder.notice_sent_at && project.value.head_contract_settings.nov_required) {
    const dueDate = project.value.head_contract_settings.nov_business_days ?
      plusBusinessDays(
        props.variationOrder.dateOfOccurrence,
        project.value.head_contract_settings.holidays,
        project.value.head_contract_settings.nov_period,
      ) :
      props.variationOrder.dateOfOccurrence.plus({ days: project.value.head_contract_settings.nov_period });

    if(noticeDueIn.value < 0) {
      nextActionText += t('HeadContract.VariationsSchedule.VariationOrderRow.timeBarred') + ' - ';
    }

    nextActionText += t('HeadContract.VariationsSchedule.VariationOrderRow.noticeOfVariation') +
      ` ${dueDate.toLocaleString()}, ${
        noticeDueIn.value < 0 ?
          t('HeadContract.VariationsSchedule.VariationOrderRow.overdueBy', { days: Math.abs(noticeDueIn.value) }) :
          noticeDueIn.value === 0 ?
          t('HeadContract.VariationsSchedule.VariationOrderRow.dueToday') :
          t('HeadContract.VariationsSchedule.VariationOrderRow.daysRemaining', { days: noticeDueIn.value })
      }.`;

    let timeBar = undefined;

    if(noticeDueIn.value < 0) {
      timeBar = {
        text: t('HeadContract.VariationsSchedule.VariationOrderRow.timeBar.timeBarred'),
        colour: '#dc2626',
      };
    } else if(noticeDueIn.value === 0) {
      timeBar = {
        text: t('HeadContract.VariationsSchedule.VariationOrderRow.timeBar.noticeDueToday'),
        colour: '#dc2626',
      };
    } else if(noticeDueIn.value < 4) {
      timeBar = {
        text: t('HeadContract.VariationsSchedule.VariationOrderRow.timeBar.noticeDueIn', { days: noticeDueIn.value }),
        colour: '#dc2626',
      };
    } else if(noticeDueIn.value < 6) {
      timeBar = {
        text: t('HeadContract.VariationsSchedule.VariationOrderRow.timeBar.noticeDueIn', { days: noticeDueIn.value }),
        colour: '#ea580c',
      };
    }

    return {
      nextActionText,
      timeBar,
    };
  } else if(
    props.variationOrder.status < VariationOrderStatus.submitted &&
    project.value.head_contract_settings.variation_submission_required
  ) {
    const dueDate = project.value.head_contract_settings.variation_submission_business_days ?
      plusBusinessDays(
        props.variationOrder.dateOfOccurrence,
        project.value.head_contract_settings.holidays,
        project.value.head_contract_settings.variation_submission_period,
      ) :
      props.variationOrder.dateOfOccurrence.plus({
        days: project.value.head_contract_settings.variation_submission_period,
      });

    if(pricingDueIn.value < 0) {
      nextActionText += t('HeadContract.VariationsSchedule.VariationOrderRow.timeBar.timeBarred') + ' - ';
    }

    nextActionText += t('HeadContract.VariationsSchedule.VariationOrderRow.variationPricingToBeIssuedBy') +
      ` ${dueDate.toLocaleString()}, ${
        pricingDueIn.value < 0 ?
          t('HeadContract.VariationsSchedule.VariationOrderRow.overdueBy', { days: Math.abs(pricingDueIn.value) }) :
          pricingDueIn.value === 0 ?
          t('HeadContract.VariationsSchedule.VariationOrderRow.dueToday') :
          t('HeadContract.VariationsSchedule.VariationOrderRow.daysRemaining', {
            days: pricingDueIn.value,
          })
      }.`;

    let timeBar = undefined;

    if(pricingDueIn.value < 0) {
      timeBar = {
        text: t('HeadContract.VariationsSchedule.VariationOrderRow.timeBar.submissionTimeBarred'),
        colour: '#dc2626',
      };
    } else if(pricingDueIn.value === 0) {
      timeBar = {
        text: t('HeadContract.VariationsSchedule.VariationOrderRow.timeBar.submissionDueToday'),
        colour: '#dc2626',
      };
    } else if(pricingDueIn.value < 4) {
      timeBar = {
        text: t('HeadContract.VariationsSchedule.VariationOrderRow.timeBar.submissionDueIn', {
          days: pricingDueIn.value,
        }),

        colour: '#dc2626',
      };
    } else if(pricingDueIn.value < 6) {
      timeBar = {
        text: t('HeadContract.VariationsSchedule.VariationOrderRow.timeBar.submissionDueIn', {
          days: pricingDueIn.value,
        }),

        colour: '#ea580c',
      };
    }

    return {
      nextActionText,
      timeBar,
    };
  }

  return {
    nextActionText: '',
    timeBar: undefined,
  };
});

const userNameTypeAhead = ref(props.variationOrder.next_action_assignee?.name);
const suggestedUsers = ref<{ id: number; name: string }[]>([]);

const getSuggestions = async () => {
  suggestedUsers.value = await projectsStore
    .searchUsers(project.value?.id, { name: userNameTypeAhead.value });

  return suggestedUsers.value.map((value) => value.name);
};

const selectUser = (index: number) => {
  nextTick(() => {
    if(suggestedUsers.value[index]) {
      nextActionAssignee.value = suggestedUsers.value[index].id;
      saveNextAction();
    }
  });
};
</script>

<style scoped></style>
